
var analyticsEvents = {
    click: function (what, where) {

    },
    addToCart: function (what, where) {

    },
    sliderView: function (pos, creativeName) {

    },

    sendActivation: function () {
        fbq('track', 'Lead', {
            content_type: 'activation',
        });
    },
    torzskartyaSend: function () {

    },
    accountActivated: function () {
        fbq('track', 'CompleteRegistration', {
            content_type: 'activation',
        });
    },
    sliderClick: function (pos, creativeName) {

    },
    popupOpen: function (prodName, placement) {

    },
    popupClose: function (prodName, placement) {

    },


};
jQuery(document).ready(function () {

    //Slider CTA
    $('#carousel .cta').on('click', function (e) {
        var name = $(this).siblings('img').attr('alt');
        analyticsEvents.click('CTA', 'Slider - ' + name);
  //      mixpanel.track('Slider' ,{"slide": name});
    });

    $('.buy-now').on('click', function (e) {
        analyticsEvents.click('CTA', 'Mobile scrolling Buy Now Button');
     //   mixpanel.track('Mobile scrolling Buy Now Button Click');
    });
    //POPUP

    $('.products .buy-btn').on('click', function (e) {
        e.preventDefault();
        var name = $(this).attr('data-name');
        analyticsEvents.click('Quick Buy', name);
   //     mixpanel.track('Quick Buy Click');
    })


    $('.product').on('click', '.buy-btn', function (e) {

        var name = $(this).attr('data-name');
        analyticsEvents.click('Quick Buy', name);
     //   mixpanel.track('Quick Buy Click',{
     //       "product":name
     //   });
    })

    $('.products .product a').not('.buy-btn').on('click', function (e) {

        switch (e.target.nodeName) {
            case 'IMG' :
                var node = 'Image';
                break;

            case 'A' :
                var node = 'Link';
                break;

            case 'SPAN' :
                var node = 'Link';
                break;
            default:
                var node = e.target.nodeName;

        }
        var name = e.target.text ? e.target.text : (e.target.alt ? e.target.alt : e.target.innerHTML);
        analyticsEvents.click(node + ' click', 'Product Grid Item - '  + name);

    })
    $('#productModal').on('click','.pill',function(e){
       analyticsEvents.click('More sizes - modal', this.innerHTML + ' - ' + $(this).parent('div').parent('div').find('h2').text());
    });

    $('#productModal').on('click','.more-info',function(e){
        analyticsEvents.click('More Info ',  'Modal - '+$(this).parent('div').parent('div').find('h2').text());
     //   mixpanel.track('Product Page More Info Click');
    });
    $('#productModal').on('click','.more-info',function(e){
        analyticsEvents.click('More Info - modal',  $(this).parent('div').parent('div').find('h2').text());
     //   mixpanel.track('Modal More Info Click');
    });
    //home-tabs

    $('#home-tab-first').on('click touch', 'button.home-tab', function(e){

        analyticsEvents.click('Home Tab',this.innerHTML );

     //   mixpanel.track('Home Tab Click ' ,{
    //        "tab":this.innerHTML
    //    });

    })

    //side menu

    $('#nav-collection li a').on('click',function(e){

        analyticsEvents.click('Side Navigation', this.innerHTML);
     //   mixpanel.track('SideNav Click ',{
     //       "nav":this.innerHTML
      //  });

    });

    $('#category-header .more,#category-header .less').click(function(){
        if($(this).hasClass('less')){
            analyticsEvents.click('Category Description Expand', 'Close');
          //  mixpanel.track('Category Description Close');
        }else{
            analyticsEvents.click('Category Description Expand', 'Open');
         //   mixpanel.track('Category Description open');
        }
    })


    $('.review-us .blue,.review-us a').click(function(){
        analyticsEvents.click('Scroll to reviews', 'Product Page');
      //  mixpanel.track('Scroll To Reviews');
    })

    $('.description').on('click','.more-info',function(e){

        analyticsEvents.click('More Info',  'Product Page - '+$(this).parent('div').parent('div').find('h1').text());
    });

    $('.info-tabs ul li a').on('click',function(e){

        analyticsEvents.click('Info Tab',this.innerHTML );

    });
    $('.info-tabs ul li a').on('click','.spr-button',function(e){

        analyticsEvents.click('Info Tab',this.innerHTML );

    })

  //  setTimeout(function(){
   //     window.SPR.$(document).on('spr:form:success',function(){
    //        ga('send', 'event', 'Submitted Review', 'click', document.title);
   //     })
  //  },10000);
  //   $(window).ready(function() {
  //       $('head script[async][src*="spr.js"]').on('load', function() {
  //           window.SPR.$(document).on('spr:form:success',function(){
  //               ga('send', 'event', 'Submitted Review', 'click', document.title);
  //           })
  //       });
  //   });

    $('#collection-filters-container').on('click','.cf-options-container span',function(e){
            if($(this).siblings('.cf-checkbox').is(':checked')){
                analyticsEvents.click('Filter unclicked',this.innerHTML );

            }else{
                analyticsEvents.click('Filter clicked',this.innerHTML );
            }
    });

    $('.pagination').on('click','span a',function(e){
        analyticsEvents.click('Pagination', $(this).text() );
    });

    $('.activate-account').click(function (e) {

    });

    $('.letsfilter').click(function (e) {

        $(e.currentTarget).parents('#collection-filters-container').find('.cf-checkbox:checked').each(function(i,e){

        });
    });
});
